<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">EX-rates</div>

      <v-flex class="d-flex align-center justify-end">
        <v-btn
          class="mx-2"
          color="light-blue"
          href="https://dashboard.stripe.com/currency_conversion"
          target="_blank"
        >
          Stripe
        </v-btn>
        <v-btn class="mx-2" color="light-blue" href="https://app.wirexapp.com/home" target="_blank">
          Wirex
        </v-btn>
        <v-btn class="mx-2" color="light-blue" href="https://crypto.com/price" target="_blank">
          CRO
        </v-btn>
        <v-btn class="mx-2" color="light-blue" href="https://www.transfergo.com/ru" target="_blank">
          Transfergo
        </v-btn>
        <v-btn
          class="mx-2"
          color="light-blue"
          href="https://www.revolut.com/currency-converter"
          target="_blank"
        >
          Revolut
        </v-btn>
        <v-btn
          class="mx-2"
          color="light-blue"
          href="https://wise.com/ru/currency-converter/"
          target="_blank"
        >
          Wise
        </v-btn>
        <v-app-bar-nav-icon class="mx-2" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </v-flex>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app bottom right temporary>
      <v-list>
        <v-list-item to="/"> Home </v-list-item>
        <!-- <v-list-item to="/wirex"> Wirex </v-list-item> -->
        <v-list-item to="/crypto"> Crypto </v-list-item>
        <v-list-item to="/cryptorank"> CryptoRank </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    drawer: false,
  }),
};
</script>
